export default function convertCurrencyCodeToSymbol(currencyCode) {
    switch (currencyCode) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'JPY':
            return '¥';
        case 'AUD':
            return 'A$';
        case 'ILS':
            return '₪';
        default:
            return currencyCode;
    }
}
